module.exports = __webpack_public_path__ + "img/140.57e1fa01.jpg";